import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import Notification from "./components/Notification";
import { ApolloProvider } from "@apollo/react-hooks";
import { shopClient } from "./apollo/clients/ApolloClientShop";
import * as serviceWorker from "./common/serviceWorker";

ReactDOM.render(
  <ApolloProvider client={shopClient}>
    {/*<Notification />*/}
    <App />
  </ApolloProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
